import { BaseComponent } from './baseComponent';

export class TimePickerModal extends BaseComponent {
  static readonly tagName = 'time-picker-modal';

  protected reader(): void {
    // Avoid re-rendering content on attribute changes (none are observed)
    if (this.innerHTML.trim()) {
      return;
    }

    this.innerHTML = `
<div x-data>
  <template x-if="$store.timePicker.isOpen">
    <!-- Backdrop for click-away -->
    <div class="fixed inset-0 z-[1000] bg-black/20"
         @click="$store.timePicker.close()">

      <!-- Modal Bubble Container (Positioned) -->
      <div class="fixed z-[1001] transition-all duration-200"
           x-bind:style="$store.timePicker.modalStyle"
           @click.stop>

        <!-- Content Box (Rounded & Clipped) -->
        <div class="relative w-full h-full overflow-hidden rounded-xl bg-[#2C2C2E] text-white shadow-2xl">
            <!-- Header / Content -->
            <div class="relative h-40 w-full">
              <!-- Center Highlight Bar -->
              <div class="absolute left-0 top-1/2 h-10 w-full -translate-y-1/2 bg-[#444444] opacity-50 pointer-events-none"></div>

              <div class="flex h-full w-full">
                <!-- Hours Column -->
                <div class="relative w-1/2 overflow-hidden">
                   <div class="h-full overflow-y-scroll snap-y snap-mandatory scroll-smooth overscroll-contain no-scrollbar py-[60px]"
                        x-init="$store.timePicker.initListScroll('hour', $el)"
                        @scroll.debounce.50ms="$store.timePicker.onScroll && $store.timePicker.onScroll('hour', $el)"
                        style="-webkit-overflow-scrolling: touch;">
                     <template x-for="hour in $store.timePicker.hours" :key="hour">
                       <div class="flex h-10 w-full snap-center items-center justify-center text-xl font-medium"
                            :class="$store.timePicker.selectedHour === hour ? 'text-white' : 'text-gray-400'"
                            @click="$store.timePicker.setHour(hour); $store.timePicker.scrollTo('hour', hour, $el)">
                         <span x-text="hour"></span>
                       </div>
                     </template>
                   </div>
                </div>

                <!-- Minutes Column -->
                <div class="relative w-1/2 overflow-hidden">
                   <div class="h-full overflow-y-scroll snap-y snap-mandatory scroll-smooth overscroll-contain no-scrollbar py-[60px]"
                        x-init="$store.timePicker.initListScroll('minute', $el)"
                         @scroll.debounce.50ms="$store.timePicker.onScroll && $store.timePicker.onScroll('minute', $el)"
                        style="-webkit-overflow-scrolling: touch;">
                     <template x-for="minute in $store.timePicker.minutes" :key="minute">
                       <div class="flex h-10 w-full snap-center items-center justify-center text-xl font-medium"
                            :class="$store.timePicker.selectedMinute === minute ? 'text-white' : 'text-gray-400'"
                            @click="$store.timePicker.setMinute(minute); $store.timePicker.scrollTo('minute', minute, $el)">
                         <span x-text="minute"></span>
                       </div>
                     </template>
                   </div>
                </div>
              </div>

              <!-- Top/Bottom Gradients (Now clipped by parent) -->
              <div class="pointer-events-none absolute left-0 top-0 h-20 w-full bg-gradient-to-b from-[#2C2C2E]/90 to-transparent"></div>
              <div class="pointer-events-none absolute bottom-0 left-0 h-20 w-full bg-gradient-to-t from-[#2C2C2E]/90 to-transparent"></div>
            </div>

            <!-- Footer Buttons -->
            <div class="flex items-center justify-between border-t border-[#444444] bg-[#2C2C2E] px-4 py-3">
              <button type="button"
                      class="text-[17px] text-[#4FA5F3] hover:text-[#4FA5F3]/80"
                      @click.stop.prevent="$store.timePicker.close()">
                リセット
              </button>
              <button type="button"
                      class="font-semibold text-[17px] text-[#4FA5F3] hover:text-[#4FA5F3]/80 disabled:opacity-50"
                      :disabled="!$store.timePicker.canConfirm()"
                      @click.stop.prevent="$store.timePicker.confirm()">
                完了
              </button>
            </div>
        </div>

        <!-- Arrow (Outside Content) -->
        <div class="absolute h-0 w-0 border-x-8 border-x-transparent"
             x-bind:style="$store.timePicker.arrowStyle"
             :class="$store.timePicker.arrowStyle?.direction === 'up' ? 'border-b-[10px] border-b-[#2C2C2E]' : 'border-t-[10px] border-t-[#2C2C2E]'">
        </div>

      </div>
    </div>
  </template>
</div>
    `.trim();
  }
}

export function mountTimePickerModal(): void {
  if (!document.querySelector(TimePickerModal.tagName)) {
    const modal = document.createElement(TimePickerModal.tagName);
    document.body.appendChild(modal);
  }
}

// Register Alpine store if not yet registered (safety for direct use without alpineController)
if (!window.Alpine && typeof document !== 'undefined') {
  // noop: Alpine will register store in controller; we avoid side effects here.
}
